import { inject, Injectable } from "@angular/core";
import { RequestService_v2 } from "./request-v2.service";

const hos_root = 'hospital';
const non_con_hos_root = 'non-contract-hospital-service';
const hos_level_root = 'hospital-level';
const pharmacy_root = 'pharmacy';
const con_hos_root = 'hospital-service';
@Injectable({
	providedIn: 'root',
})
export class HospitalService {

	private requestService: RequestService_v2 = inject(RequestService_v2);

	constructor() {

	}
	getHospitals(data: {
		search?: string;
		contract_type?: string;
		pro_id?: number;
		page: number;
		count: number;
	}) {
		return this.requestService.postJSON(hos_root, data, {
			errSnackbar: true,
			loading: true,
		});
	}
	getHospitalById(_id: string) {
		return this.requestService.getJSON(`${hos_root}/${_id}`, {}, {
			errSnackbar: true,
			loading: true,
		});
	}

	getNonContractHospitals(data: {
		search?: string;
		is_formal?: boolean;
		pro_id?: number;
		hospital?: string;
		hospital_ward?: string;
		page: number;
		count: number;
	}) {
		return this.requestService.postJSON(non_con_hos_root, data, {
			errSnackbar: true,
			loading: true,
		});
	}

	getContractHospitals(data: {
		search?: string;
		is_formal?: boolean;
		pro_id?: number;
		hospital?: string;
		hospital_ward?: string;
		page: number;
		count: number;
	}) {
		return this.requestService.postJSON(con_hos_root, data, {
			errSnackbar: true,
			loading: true,
		});
	}

	getHospitalLevelByID(hospital_level_id: string) {
		return this.requestService.getJSON(`${hos_level_root}/${hospital_level_id}`, {
			errSnackbar: true,
			loading: true,
		});
	}

	getPharmacies(data: {
		search?: string;
		page: number;
		count: number;
	}) {
		return this.requestService.postJSON('pharmacy', data, {
			errSnackbar: true,
			loading: true,
		});
	}

}

